<app-auth-shell>
  @switch (mode) {
    @case ('verifying') {
      <div class="af-center" role="status">
        <span class="af-badge"><span class="af-spinner" aria-hidden="true"></span></span>
        <div class="af-head">
          <h1>Confirming…</h1>
          <p>One moment while we confirm your email.</p>
        </div>
      </div>
    }

    @case ('done') {
      <div class="af-center">
        <span class="af-badge af-badge--success" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>
        </span>
        <div class="af-head">
          <h1>Email confirmed</h1>
          <p>{{ message }}</p>
        </div>
        <a class="af-btn af-btn--primary" routerLink="/login">Sign in</a>
      </div>
    }

    @case ('failed') {
      <div class="af-center">
        <span class="af-badge af-badge--danger" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
        </span>
        <div class="af-head">
          <h1>{{ linkExpired ? 'Link expired' : "That link didn't work" }}</h1>
          <p>{{ message }}</p>
        </div>
      </div>
      <form class="af-form" (ngSubmit)="resend()" novalidate>
        <div class="af-field">
          <label class="af-label" for="ve-email">Your email</label>
          <input id="ve-email" class="af-input" type="email" [formControl]="emailControl" autocomplete="email"
            inputmode="email" autocapitalize="off" spellcheck="false"
            [class.is-invalid]="emailControl.invalid && emailControl.touched" />
          @if (emailControl.invalid && emailControl.touched) {
            <p class="af-error">Enter a valid email address.</p>
          }
          @if (resendError) {
            <p class="af-error" role="alert">{{ resendError }}</p>
          }
        </div>
        <button type="submit" class="af-btn af-btn--primary" [disabled]="resendBusy">
          @if (resendBusy) { <span class="af-spinner" aria-hidden="true"></span> Sending… } @else { Send a new link }
        </button>
      </form>
      <p class="af-foot">Already confirmed? <a class="af-link" routerLink="/login">Sign in</a></p>
    }

    @default {
      <div class="af-center">
        <span class="af-badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/></svg>
        </span>
        <div class="af-head">
          <h1>Check your inbox</h1>
          @if (email) {
            <p>We sent a confirmation link to <strong>{{ email }}</strong>. Open it to finish creating your account.</p>
          } @else {
            <p>We sent you a confirmation link. Open it to finish creating your account.</p>
          }
        </div>
      </div>

      @if (resendSent) {
        <div class="af-alert af-alert--success" role="status"><p>We've sent the link again. It can take a minute to arrive.</p></div>
      }
      @if (resendError) {
        <div class="af-alert af-alert--error" role="alert"><p>{{ resendError }}</p></div>
      }

      <div class="af-stack">
        <button type="button" class="af-btn af-btn--ghost" (click)="resend()" [disabled]="resendBusy || wait > 0 || !email">
          @if (resendBusy) {
            <span class="af-spinner" aria-hidden="true"></span> Sending…
          } @else if (wait > 0) {
            Send again in {{ wait }}s
          } @else {
            Send the link again
          }
        </button>
        <p class="af-hint af-center">Can't find it? Check your spam or promotions folder.</p>
      </div>

      <p class="af-foot">
        Wrong email? <a class="af-link" routerLink="/signup">Start again</a>
        <span aria-hidden="true"> · </span>
        <a class="af-link" routerLink="/login">Sign in</a>
      </p>
    }
  }
</app-auth-shell>
